/**
 * Exhaustiveness-Helper für diskriminierte Unions.
 *
 * Aufrufer übergeben einen Wert, der zur Compile-Zeit bereits den Typ `never`
 * haben muss — z.B. der Default-Zweig eines `switch`, der alle Diskriminanten
 * abdeckt. Fehlt ein Case, weigert sich der Compiler, einen `never`-Wert zu
 * akzeptieren, und der Build bricht.
 *
 * Zur Laufzeit wird zusätzlich geworfen — schützt gegen Werte aus untyped
 * Quellen (z.B. JSON-Parsing) und macht offensichtlich, dass die Stelle nicht
 * erreichbar sein sollte.
 *
 * @param value Wert, der laut Typsystem unerreichbar ist.
 */
export function assertNever(value: never): never {
  throw new Error(`Unerwarteter Wert in erschöpfendem Switch: ${JSON.stringify(value)}`);
}
